<ng-container *ngIf="styledTable && styledTable.Title && styledTable.contents && styledTable.Footnotes">
    <div fxFlex="1 1 100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="2px" class="table-container">
        <span [id]="tableID" *ngIf="noModal" class="styled-table-title">Table {{styledTable.tableNumber}}:
            {{ styledTable.Title }}</span>
        <markdown class="styled-table" [ngClass]="{'small': small}">{{ styledTable.contents }}</markdown>
        <markdown class="styled-table-footnotes" [ngClass]="{'small': small}" (click)="ui.onMarkdownClick($event);">
            {{ styledTable.Footnotes }}</markdown>
    </div>
</ng-container>
